
import React, { useState, useEffect } from "react";
import { Box, Typography, Chip, Grid, Tabs, Tab } from "@mui/material";
import ProcurementHotelBoughtOutItems from "./HotelBOIList";
import ProcurementSitcDetail from "./Sitc";
import { FaPlus } from "react-icons/fa6";
import CustomButton from "components/Button";
import ProcurementHotelSitcDetail from "./HotelSitc";
import AddProcurement from "./addProcurement";
import ProcurementDpItemsList from "./DpItemsList";
import ProcurementSitc from "./ProcurementSitcSummary";
import ProcurementHotelSitc from "./ProcurementHotelSitcSummary";
import SoftCostList from "./softCostList";
import { usePermission } from "hooks/usePermission";
import { PROCUREMENT_CREATE } from "helpers/permissionConfig";
import { useGetLastUpdatedOnStatusQuery } from "store/slices/apis/projectStatusApiSlice";
import ProjectLastUpdatedOn from "components/ProjectLastUpdatedOn";
import TrackerPageHeader from "components/TrackerPageHeader";
import { useParams } from "react-router-dom";
import { PROCUREMENT_TABS_CONFIG, PROCUREMENT_SUB_TABS_CONFIG } from "config";


// const actionStatusOptions = [
//     { label: "Sitc", value: "Procurement Plan - Sitc" },
//     { label: "Dp Items", value: "Procurement Plan - Dp Items" },
//     { label: "Hotel Sitc", value: "Procurement Plan - Hotel Sitc" },
//     { label: "Hotel - Bought Out Items", value: "Hotel - Bought Out Items" },
//     { label: "Plan - Soft Cost", value: "Procurement Plan - Soft Cost" },
// ];

// const adminTabsOption = [
//     { label: "Sitc", value: "Procurement Plan - Sitc" },
//     { label: "Dp Items", value: "Procurement Plan - Dp Items" },
//     { label: "Hotel Sitc", value: "Procurement Plan - Hotel Sitc" },
//     { label: "Hotel - Bought Out Items", value: "Hotel - Bought Out Items" },
//     { label: "Soft Cost", value: "Procurement Plan - Soft Cost" },
//     { label: "Cancelled-Items", value: "Cancelled-Items" },

// ]

const ProcurementList = () => {
    const [tabValue, setTabValue] = useState(0);
    const [subTabValue, setSubTabValue] = useState(0);
    const [isAdd, setIsAdd] = useState(false)
    const { projectId } = useParams()



    const createAccess = usePermission(PROCUREMENT_CREATE)

    // const subTabs = [
    //     { label: "Summary", value: 0 },
    //     { label: "Detail", value: 1 },
    // ];

    // const adminSubTabs = [
    //     { label: "Sitc", value: 0 },
    //     { label: "Dp-Items", value: 1 },
    //     { label: "Hotel-Sitc", value: 2 },
    //     { label: "Hotel-Bought Out Items", value: 3 },
    //     { label: "Soft Cost", value: 4 },


    // ]

    const isAdminAccess = usePermission()

    const projectTabsConfig = PROCUREMENT_TABS_CONFIG[projectId] || PROCUREMENT_TABS_CONFIG.default;

    const filteredTabs = isAdminAccess
        ? projectTabsConfig.admin
        : projectTabsConfig.user;


    const isCancelledTab = tabValue === filteredTabs.length - 1;

    const projectSubTabsConfig =
        PROCUREMENT_SUB_TABS_CONFIG[projectId] || PROCUREMENT_SUB_TABS_CONFIG.default;

    const filteredSubTabs = isCancelledTab
        ? projectSubTabsConfig.cancelled
        : projectSubTabsConfig.normal;


    const activeTab = filteredTabs[tabValue]?.value;

    const activeSubTab = filteredSubTabs[subTabValue]?.value

    const { data: procurementData } = useGetLastUpdatedOnStatusQuery({ ProjectId: projectId });


    const handleAdd = () => {
        setIsAdd((prev) => !prev);
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        setSubTabValue(0);
    };

    const handleSubTabChange = (event, newValue) => {
        setSubTabValue(newValue);
        console.log("val", newValue)
    };


    return <>

        <TrackerPageHeader title="Procurement" description="Track procurement plans, packages, progress, and cancelled items.">
            <ProjectLastUpdatedOn date={procurementData?.procurement} />
        </TrackerPageHeader>
        <Grid container spacing={2} sx={{ p: 2 }}>
            <Grid size={12}>
                <Box
                    sx={{
                        width: "100%",
                        borderBottom: "2px solid #ECECEC",
                        overflowX: "auto",
                        whiteSpace: "nowrap",
                        p: 0,
                        display: "flex", alignItems: "center", justifyContent: 'space-between',
                        "-webkit-overflow-scrolling": "touch",
                    }}
                >
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        TabIndicatorProps={{ style: { display: "none" } }}
                        variant="scrollable"
                        scrollButtons={false}
                        sx={{
                            justifyContent: "flex-start !important",
                            alignItems: "flex-start",
                            "& .MuiTabs-flexContainer": {
                                justifyContent: "flex-start !important",
                                gap: "30px",
                            },
                        }}
                    >
                        {filteredTabs.map((item, index) => (
                            <Tab
                                key={index}
                                label={
                                    <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                        <Typography
                                            sx={{
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                lineHeight: "100%",
                                                color: tabValue === index ? "#0E73F6" : "#7E7E7E",
                                                fontFamily: "Outfit, sans-serif"
                                            }}
                                        >
                                            {item.label}
                                        </Typography>

                                    </Box>
                                }
                                sx={{
                                    textTransform: "none",
                                    minWidth: "auto",
                                    paddingBottom: "14px",
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                    borderBottom: tabValue === index ? "2px solid #0E73F6" : "2px solid transparent",
                                }}
                            />
                        ))}
                    </Tabs>
                    {createAccess &&
                        <CustomButton
                            label="Create Procurement"
                            startIcon={<FaPlus />}
                            color="primary"
                            onClick={handleAdd}
                            sx={{
                                backgroundColor: "#2563EB",
                                fontFamily: 'Outfit',
                                fontWeight: 500,
                                fontSize: '14px',
                                lineHeight: '100%',
                                letterSpacing: '0px',
                            }}
                        />
                    }

                </Box>
            </Grid>

            {(tabValue === 0 || tabValue === 2 || tabValue === filteredTabs.length - 1) && (
                <Box
                    sx={{
                        width: "100%",
                        //borderBottom: "2px solid #ECECEC",
                        overflowX: "auto",
                        whiteSpace: "nowrap",
                        mt: 1,
                        ml: 2,
                    }}
                >
                    <Tabs
                        value={subTabValue}
                        onChange={handleSubTabChange}
                        TabIndicatorProps={{ style: { display: "none" } }}
                        variant="scrollable"
                        scrollButtons={false}
                        sx={{
                            "& .MuiTabs-flexContainer": {
                                gap: "30px",
                            },
                        }}
                    >
                        {filteredSubTabs.map((item, index) => (
                            <Tab
                                key={index}
                                label={
                                    <Typography
                                        sx={{
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            lineHeight: "100%",
                                            color: subTabValue === index ? "#0E73F6" : "#7E7E7E",
                                            fontFamily: "Outfit, sans-serif",
                                        }}
                                    >
                                        {item.label}
                                    </Typography>
                                }
                                sx={{
                                    textTransform: "none",
                                    minWidth: "auto",
                                    paddingBottom: "5px",
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                    borderBottom:
                                        subTabValue === index
                                            ? "2px solid #0E73F6"
                                            : "2px solid transparent",
                                }}
                            />
                        ))}
                    </Tabs>
                </Box>
            )}

            {activeTab === "Procurement Plan - Sitc" && (
                <ProcurementSitc
                    subTabValue={activeSubTab}
                    canceltabValue={tabValue}
                    tabLength={filteredTabs.length - 1}
                />
            )}

            {activeTab === "Procurement Plan - Dp Items" && (
                <ProcurementDpItemsList
                    canceltabValue={tabValue}
                    tabLength={filteredTabs.length - 1}
                />
            )}

            {activeTab === "Procurement Plan - Hotel Sitc" && (
                <ProcurementHotelSitc
                    subTabValue={activeSubTab}
                    canceltabValue={tabValue}
                    tabLength={filteredTabs.length - 1}
                />
            )}

            {activeTab === "Hotel - Bought Out Items" && (
                <ProcurementHotelBoughtOutItems
                    canceltabValue={tabValue}
                    tabLength={filteredTabs.length - 1}
                />
            )}

            {activeTab === "Procurement Plan - Soft Cost" && (
                <SoftCostList
                    canceltabValue={tabValue}
                    tabLength={filteredTabs.length - 1}
                />
            )}
            {activeTab === "Cancelled-Items" && activeSubTab === "Procurement Plan - Sitc" && (
                <ProcurementSitc
                    canceltabValue={tabValue}
                    tabLength={filteredTabs.length - 1}
                    subTabValue={activeSubTab}
                />
            )}

            {activeTab === "Cancelled-Items" && activeSubTab === "Procurement Plan - Dp Items" && (
                <ProcurementDpItemsList
                    canceltabValue={tabValue}
                    tabLength={filteredTabs.length - 1}
                    subTabValue={activeSubTab}
                />
            )}

            {activeTab === "Cancelled-Items" && activeSubTab === "Procurement Plan - Hotel Sitc" && (
                <ProcurementHotelSitc
                    canceltabValue={tabValue}
                    tabLength={filteredTabs.length - 1}
                    subTabValue={activeSubTab}
                />
            )}

            {activeTab === "Cancelled-Items" && activeSubTab === "Hotel - Bought Out Items" && (
                <ProcurementHotelBoughtOutItems
                    canceltabValue={tabValue}
                    tabLength={filteredTabs.length - 1}
                    subTabValue={activeSubTab}
                />
            )}

            {activeTab === "Cancelled-Items" && activeSubTab === "Procurement Plan - Soft Cost" && (
                <SoftCostList
                    canceltabValue={tabValue}
                    tabLength={filteredTabs.length - 1}
                    subTabValue={activeSubTab}
                />
            )}

        </Grid>
        {isAdd &&
            <AddProcurement open={isAdd} handleClose={handleAdd} />
        }
    </>
}

export default ProcurementList;
